import { startCase } from "lodash";

import { StyledBaseRow } from "../styled-components";

import { CustomCell } from "./cells";

type HeaderProps = {
  headers: string[];
};

export const Header = ({ headers }: HeaderProps) => (
  <StyledBaseRow>
    <CustomCell />
    {headers.map((item, index) => (
      <CustomCell key={index} align="center">
        {startCase(item)}
      </CustomCell>
    ))}
  </StyledBaseRow>
);

export default Header;
